// src/pages/HomePage.js
import React from "react";
import HeroBanner from "../components/Hero/HeroBanner";
import ProductsSection from "../components/Products/ProductsSection";
import CollectionsStrip from "../components/Categories/CollectionsStrip";
import "./HomePage.css";

export default function HomePage() {
  return (
    <main>
      <HeroBanner />
      <CollectionsStrip />
      <ProductsSection />
    </main>
  );
}
